import React from 'react';

import styled from '@emotion/styled';

import ChartWrapper from '../../../components/Charts/ChartWrapper';
import PieChart from '../../../components/Charts/PieChart';

interface ChatItem {
  name: string;
  value: number;
  color: string;
  textColor: string;
}

interface DeliveryStatusDistributionProps {
  userExitReason?: ChatItem[];
  driverTypeDistribution?: ChatItem[];
}

const DeliveryStatusDistribution = ({
  userExitReason,
  driverTypeDistribution,
}: DeliveryStatusDistributionProps) => {
  // const userExitReason = [
  //   {
  //     name: 'Voluntary exit',
  //     value: 4,
  //     color: theme.palette.greenColor,
  //     textColor: '#ffffff',
  //   },
  //   {
  //     name: 'End of contract',
  //     value: 2,
  //     color: '#C8DDD1',
  //     textColor: '#ffffff',
  //   },
  //   {
  //     name: 'Termination',
  //     value: 6,
  //     color: '#C8DDD1',
  //     textColor: '#ffffff',
  //   },
  // ];

  // const driverTypeDistribution = [
  //   {
  //     name: 'Gig Drivers (Active)',
  //     value: 4,
  //     legendValue: 19,
  //     color: '#5B91F5',
  //     textColor: '#ffffff',
  //   },
  //   {
  //     name: 'Exclusive Drivers (Active)',
  //     value: 6,
  //     legendValue: 4,
  //     color: '#0F3A84',
  //     textColor: '#ffffff',
  //   },
  //   {
  //     name: 'Exited Drivers',
  //     value: 8,
  //     legendValue: 9,
  //     color: '#BFD2F6',
  //     textColor: '#ffffff',
  //   },
  // ];

  return (
    <Container>
      <ChartWrapper
        label='Driver Status by Worker Type Distribution'
        maxWidth='100%'
      >
        <PieChart
          data={driverTypeDistribution}
          aspect={1.2}
          outerRadius={130}
          cy='44%'
          showLabels
          showPercentInLabel
          decimalPlaces={1}
          legendVerticalAlign='middle'
          legendAlign='right'
          legendLayout='vertical'
          legendValueFormatter={(item) => item.legendValue ?? item.value}
          tooltipValueFormatter={(value) => `${value.toFixed(1)}%`}
        />
      </ChartWrapper>

      <ChartWrapper label='User Exit Reason' maxWidth='100%'>
        <PieChart
          data={userExitReason}
          aspect={1.2}
          outerRadius={130}
          cy='44%'
          showLabels
          showPercentInLabel
          decimalPlaces={1}
          legendVerticalAlign='middle'
          legendAlign='right'
          legendLayout='vertical'
          legendValueFormatter={(item) => item.legendValue ?? item.value}
          tooltipValueFormatter={(value) => `${value.toFixed(1)}%`}
        />
      </ChartWrapper>
    </Container>
  );
};

export default DeliveryStatusDistribution;

const Container = styled.div`
  width: 100%;
  grid-column: span 3;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
`;
